var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-dropzone',{attrs:{"options":_vm.dropzoneOptions},on:{"vdropzone-sending":_vm.sendingEvent,"vdropzone-success":_vm.onSuccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }